const objectToString = (obj, prefix = "") => {
  return Object.entries(obj).flatMap(([key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === "object")
      return objectToString(value, newKey);
    return `${newKey}: ${value}`;
  });
};

export {
    objectToString
};